import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';

class GroupChangesSelection implements angular.IComponentController {
    currentUsage;
    isLoading: boolean;
    share: any;

    static $inject = [];

    checkDelete(usageGuid, action) {
        if (this.share.usages && this.share.usages[usageGuid]) {
            this.currentUsage = this.share.usages[usageGuid];
            angular.element('#usage-modal').modal('show');
        } else {
            action();
        }
    }
}

export const wtGroupChangesSelection: ComponentDefinition = {
    componentId: 'wtGroupChangesSelection',
    controller: GroupChangesSelection,
    controllerAs: 'vm',
    template: require('./groupChangesSelection.component.html'),
    bindings: {
        share: '='
    }
};